import '../../resources/css/common/ModalPickupList.scss';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reactFormatter } from 'react-tabulator';
import ModalPickList from '../common/ModalPickList';

let componentProps = null;

const checkEnabled = (cell, isChecked, isMultiChoose) => {
  if (cell) {
    if (isChecked) {
      if (!isMultiChoose) {
        const rows = cell.table.getRows();

        // check has choose other value
        rows.forEach(row => {
          let checkCell = row._row.getCell('PICK_CHECKED');
          if (checkCell.getValue()) {
            checkCell.setValue(0);
            row.deselect();
          }
        });
      }

      cell.setValue(1);
      cell.row.component.select();
    } else {
      cell.setValue(0);
      cell.row.component.deselect();
    }
  }
}

const EnabledBtn = (props) => {
  let iconContent;
  const cellRef = componentProps.isReadonly ? null : props.cell._cell;
  if (props.cell._cell.value) {
    iconContent = <span className='icon-btn-checkbox-p' onClick={() => checkEnabled(cellRef, false, props.isMultiChoose)}></span>;
  } else {
    iconContent = <span className='icon-btn-checkbox-n' onClick={() => checkEnabled(cellRef, true, props.isMultiChoose)}></span>;
  }

  return <div className='area-enabled-icon'>{ iconContent }</div>
}

class ModalPickDeviceList extends Component {

  constructor(props) {
    super(props);

    componentProps = props;
  }  

  // open pick name
  modalName = 'PickDeviceList'

  // open pick title
  // modalTitle = 'Pick Device List'

  // for pick up back data key
  pickUniqueId = 'id'

  // pick is multi choose or one choose
  isMultiChoose = true

  // open pick list columns
  columns = [
    { title: "Add", field: "PICK_CHECKED", width: 80, formatter: reactFormatter(<EnabledBtn isMultiChoose={ this.isMultiChoose } />) },
    // { title: "ID", field: "id", width: 100 },
    { title: "Mac", field: "mac" },
    { title: "Name", field: "name" }
  ]

  render() {
    const { deviceList } = this.props;

    return (
      <div className='area-pick-device'>
          <ModalPickList
            modalName={ this.modalName }
            modalTitle={ this.props.modalPick.modalAction === 'bind' ? 'Available device List' : 'Lift bind device list' }
            pickUniqueId={ this.pickUniqueId }
            isMultiChoose={ this.isMultiChoose }
            columns={ this.columns }
            dataList={ deviceList }
          >
          </ModalPickList>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    deviceList: state.deviceReducers.deviceList,
    modalPick: state.commonReducers.modalPick
  }
}

export default connect(
  mapStateToProps,
  { }
)(ModalPickDeviceList)